import { useMemo, useState } from 'react'
import debounce from 'util/debounce'

const useDebounceInput = (value: string = '', delay: number = 600) => {
  const [input, setInput] = useState(value)
  const [debounceInput, setDebounceInput] = useState(input)

  const debounceUpdate = useMemo(
    () =>
      debounce(delay, (value: string) => {
        setDebounceInput(value)
      }),
    [delay]
  )

  const updateInput = (value: string) => {
    setInput(value)
    debounceUpdate(value)
  }

  return {
    input,
    debounceInput,
    updateInput
  }
}

export default useDebounceInput
